import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import React, { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { ToastRegion } from './components/ToastRegion';
import { I18nProvider } from './components/I18nProvider';
import { registerFontAwesomeIcons } from './lib/fontawesome';
import './lib/i18n';
import installAxiosMocks from './mocks/setupAxiosMock';
import { uhidService } from './services/uhidService';
import { useConfigStore } from './state/config';
import './styles/globals.css';
// import './styles/yodlee-app-shell.css';
import './styles/appShell.css';
import './styles/dashboard-pages.css';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: false,
      staleTime: 5 * 60 * 1000, // 5 minutes
    },
  },
});

const LoadingFallback = () => (
  <div className="min-h-screen flex items-center justify-center">
    <div className="animate-spin rounded-full h-32 w-32 border-b-2 border-blue-600"></div>
  </div>
);

// Initialize FontAwesome icons
registerFontAwesomeIcons();

// Install Axios mocks in dev-only when enabled
installAxiosMocks();

// Initialize configuration
const initializeConfig = async () => {
  const configStore = useConfigStore.getState();
  
  try {
    configStore.setLoading(true);
    const configResponse = await uhidService.getConfig();
    
    if (configResponse) {
      configStore.setConfig(configResponse);
      console.log('Configuration loaded successfully:', configResponse);
    }
  } catch (error) {
    console.error('Failed to load configuration:', error);
    configStore.setError('Failed to load application configuration');
  } finally {
    configStore.setLoading(false);
  }
};

// Load configuration on app startup
initializeConfig();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <Suspense fallback={<LoadingFallback />}>
      <I18nProvider>
        <QueryClientProvider client={queryClient}>
          <BrowserRouter>
            <App />
            <ToastRegion />
           
          </BrowserRouter>
        </QueryClientProvider>
      </I18nProvider>
    </Suspense>
  </React.StrictMode>,
);
